<template>
  <v-dialog v-model="getModalCadastroBandeiraCartao" max-width="720px">
    <v-card outlined>
      <v-card-title>Cadastro de Bandeira de Cartão</v-card-title>
      <v-card-text>
        <v-form ref="form" class="px-3">
          <v-layout row wrap class="mt-5">
            <v-flex xs12 md12>
              <v-text-field
                v-model="getBandeiraCartao.nome"
                label="Nome"
                :rules="rules.nome"
                outlined
                dense
                
              ></v-text-field>
              <!-- <v-flex xs12 md12>
                <v-text-field v-model="getBandeiraCartao.codigo" label="Código NF-e" outlined dense></v-text-field>
              </v-flex> -->
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" @click="setModalCadastroBandeiraCartao(false)" outlined dense>Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="salvar" outlined dense>Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters(["getModalCadastroBandeiraCartao", "getBandeiraCartao"]),
  },
  methods: {
    ...mapActions(["setModalCadastroBandeiraCartao", "salvarBandeiraCartao", "atualizarBandeiraCartao"]),
    salvar() {
      if (this.$refs.form.validate()) {
        let data = this.getBandeiraCartao;
        if (this.getBandeiraCartao.id) {
          this.atualizarBandeiraCartao(data);
        } else {
          this.salvarBandeiraCartao(data);
        }
      }
    },
  },
};
</script>
